import { selectVirtualBackgroundStatus } from 'features/virtual-backgrounds/selectors';
import { call, put, select } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';
import { eventBus } from 'utils/eventBus';
import {
  virtualBackgroundActivationFailed,
  virtualBackgroundChangeStarted,
  virtualBackgroundChangeFulfilled,
} from 'features/virtual-backgrounds/virtualBackgroundsSlice';
import { VirtualBackgroundsStatus } from 'features/virtual-backgrounds/types';
import { RoomStatus } from 'features/room/types';
import { selectRoomStatus } from 'features/room/roomSlice';

export function* resetVirtualBackgroundSaga() {
  const roomStatus: RoomStatus = yield select(selectRoomStatus);

  if (roomStatus !== 'joined') {
    // Nothing is on the wire outside the room, and the reducer already cleared the selection.
    eventBus.sendMessage('virtualBackgroundDisabled', {});
    return;
  }

  const status: VirtualBackgroundsStatus = yield select(selectVirtualBackgroundStatus);
  if (status === 'updating') {
    return;
  }

  yield put(virtualBackgroundChangeStarted());

  try {
    yield call(RTCClient.publishingFeed.resetVirtualBackground);
    eventBus.sendMessage('virtualBackgroundDisabled', {});
    yield put(virtualBackgroundChangeFulfilled());
  } catch (error) {
    yield put(virtualBackgroundActivationFailed({ reason: 'failed' }));
  }
}
